import { render, staticRenderFns } from "./12Hours.vue?vue&type=template&id=64afb0b1&scoped=true&"
import script from "./12Hours.vue?vue&type=script&lang=js&"
export * from "./12Hours.vue?vue&type=script&lang=js&"
import style0 from "./12Hours.vue?vue&type=style&index=0&id=64afb0b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64afb0b1",
  null
  
)

export default component.exports